import { ReactNode, useState } from 'react';
import toast from 'react-hot-toast';

import { parseError } from '@/lib/utils/common.ts';

import ErrorInfoPanel from '@/components/common/InfoPanels/ErrorInfoPanel';

const useAxiosErrorHandler = () => {
  const [errorContent, setErrorContent] = useState<ReactNode | null>(null);

  const parseAndShowError = (
    error: unknown,
    getErrorContent = false,
    addition?: ReactNode
  ) => {
    const wrapError = (message: string, code?: string) => {
      if (getErrorContent) {
        setErrorContent(
          <ErrorInfoPanel addition={addition}>
            <p>
              {code && <>{code}: </>}
              {message}
            </p>
          </ErrorInfoPanel>
        );
      } else {
        toast.error(message);
      }
    };

    const { errorMessage, errorCode } = parseError(error);
    wrapError(errorMessage, errorCode);

    console.error(error);
  };

  return {
    parseError,
    parseAndShowError,
    errorContent,
  };
};

export default useAxiosErrorHandler;
